var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-sample" }, [
    _c("h1", [_vm._v("Current Viewport")]),
    _vm._v("\n    width: "),
    _c("span", { domProps: { textContent: _vm._s(_vm.width) } }),
    _c("br"),
    _vm._v("\n    height: "),
    _c("span", { domProps: { textContent: _vm._s(_vm.height) } }),
    _c("br"),
    _vm._v("\n    mq: "),
    _c("span", { domProps: { textContent: _vm._s(_vm.mq.query) } })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b55e67d", { render: render, staticRenderFns: staticRenderFns })
  }
}